import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CopyIcon from 'mdi-material-ui/ContentCopy';
import { IconButton } from '../IconButton';
import { useCopyToClipboard } from '../../utils/useCopyToClipboard';
/**
 * Button that will copy the 'valueToCopy' prop's value to the clipboard when
 * clicked.
 */ export function CopyToClipboardButton({ valueToCopy, innerSx, variant = 'secondary', ...props }) {
    const copy = useCopyToClipboard();
    return /*#__PURE__*/ _jsx(IconButton, {
        title: "copy-to-clipboard",
        variant: variant,
        onClick: async (e)=>{
            try {
                e.preventDefault();
                e.stopPropagation();
                await copy(valueToCopy);
            } catch (error) {
            // Error is handled by the hook (shows snackbar), we just need to catch it here
            // to prevent unhandled promise rejections
            }
        },
        ...props,
        children: /*#__PURE__*/ _jsx(CopyIcon, {
            sx: innerSx
        })
    });
}

//# sourceMappingURL=CopyToClipboardButton.js.map